module.exports = __webpack_public_path__ + "img/payment-error.5ed39dbc.svg";